export default __webpack_public_path__ + "static/39156-4ffc65ad00190ea12c9f3764ec28080b.jpg";